import type { Read } from '@signalvote/data';

/** The value a read holds when it answered for these params, for a view that takes a value or nothing. */
export function readyData<T>(read: Read<T>): T | undefined {
  return read.status === 'ready' ? read.data : undefined;
}

/** Still waiting on its first answer, as opposed to answered, failed or offline. */
export function isLoading(read: { status: string }): boolean {
  return read.status === 'loading' || read.status === 'idle';
}
